import dayjs from 'dayjs';
import { getRandomColor } from 'pages/admin/CostDashboard/helper';
import { RaasMetricsData, RaasMetricsResult } from 'pages/raas/hooks';
import { useMemo } from 'react';
import { Metric } from 'shared/components/metric';
import { PeriodicCostRecordsReply } from 'shared/types/protoc-gen/bffbillsystem';

interface IPeriodicCostMetric {
  periodicCostData?: PeriodicCostRecordsReply;
  isLoading: boolean;
}

const PeriodicCostMetric: React.FC<IPeriodicCostMetric> = ({ isLoading, periodicCostData }) => {
  const metricData: RaasMetricsResult<RaasMetricsData> = useMemo(() => {
    const rawItems = periodicCostData?.items ?? [];

    const resultMap = new Map<string, RaasMetricsData>();

    rawItems.forEach(item => {
      const timestamp = item.startTime;
      const unitName = item.billingUnit?.name || 'Unknown';
      const value = item.costCounter ?? 0;

      let entry = resultMap.get(timestamp);

      if (!entry) {
        entry = { date: dayjs(timestamp).format('YYYY-MM-DD') };
        resultMap.set(timestamp, entry);
      }

      entry[unitName] = value;
    });

    const data = Array.from(resultMap.values());
    const seen = new Set<string>();
    const dataKeys = rawItems
      .map(item => item.billingUnit?.name || 'Unknown')
      .filter(name => {
        if (seen.has(name)) return false;
        seen.add(name);

        return true;
      })
      .map(name => ({
        name,
        color: getRandomColor(),
      }));

    return { data, dataKeys };
  }, [periodicCostData]);

  return (
    <Metric
      chartType="area"
      data={metricData}
      description="Cost over time per billing unit"
      hideLegend
      id="periodic-cost-by-unit"
      loading={isLoading}
      title={'Periodic cost by Unit'}
      xAxisProps={{
        dataKey: 'date',
      }}
    />
  );
};

export default PeriodicCostMetric;
